/* istanbul ignore file */
import assetNoteValidation from 'domain/finance/assets/Timeline/note/form/assetNoteValidation';
import { useBaseCrudService } from 'framework/crud';
import { useFinanceApi } from 'infrastructure/api';
import { useAssetId } from 'domain/finance/assets/shared/useAssetRouting';

export const CREATE_ASSET_NOTE_PERMISSION = 'COMPANY_CREATE_ASSET_NOTE';
export const DELETE_ASSET_NOTE_PERMISSION = 'COMPANY_DELETE_ASSET_NOTE';

const useAssetNoteService = () => {
  const inventoryNumber = useAssetId();

  const { deleteById, update } = useBaseCrudService({
    listResourceUrl: `/asset/${inventoryNumber}/note`,
    singleResourceUrl: `/asset/${inventoryNumber}/note/:id`,
    useService: useFinanceApi,
  });

  return {
    getValidationSchema: () => Promise.resolve(assetNoteValidation),
    deleteById,
    update,
  };
};

export default useAssetNoteService;
